import { GuxCardAccent } from "genesys-spark-components/dist/types/components/stable/gux-card/gux-card.types";
import { ReactNode } from "react";
import { GuxCard } from "genesys-spark-components-react";
import "./Card.less";
import { useAppSelector } from "app/hooks";
import { selectFeatureToggle } from "features/featureToggles/featureToggleSlice";
import FeatureToggle from "enums/FeatureToggle";

export function Card({
    children,
    className,
    accent = "bordered",
}: {
    children: ReactNode;
    className?: string;
    accent?: GuxCardAccent;
}) {
    const isFlareThemeEnabled = useAppSelector((state) =>
        selectFeatureToggle(state, FeatureToggle.SPARK_FLARE)
    );

    const getFlareClasses = (): string => {
        if (!isFlareThemeEnabled || !className) return "";

        const classes: string[] = [];
        if (className.includes("filled")) classes.push("filled-flare");
        if (className.includes("error")) classes.push("error-flare");

        return classes.join(" ");
    };

    const customizedClasses = getFlareClasses();

    const classes =
        className !== undefined
            ? `Card ${className} ${customizedClasses}`
            : "Card";

    if (className?.includes("filled")) {
        return (
            <div className={classes}>
                <div className="card-content">{children}</div>
            </div>
        );
    } else {
        return (
            <GuxCard className={classes} accent={accent}>
                <div className="card-content">{children}</div>
            </GuxCard>
        );
    }
}
